/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

/**
 * @description Estimation details for a projected item.
 */
export const projectedEstimationSchema = z
  .object({
    estimationSchemeId: z.int().nullish(),
    highEffort: z.int().nullish(),
    id: z.int().nullish(),
    label: z.string().nullish(),
    lowEffort: z.int().nullish(),
    priority: z.string().nullish(),
  })
  .describe('Estimation details for a projected item.');
